export default () => ({
  showModal: false,
  modalsToOpen: []
})
